module.exports = __webpack_public_path__ + "static/media/half-moon.a8166985.svg";